<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>주차서비스</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">주차서비스</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/unpaidinfo" title="주차요금정산">주차요금정산</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">정기권</p>
          <ul class="depth">
            <li><router-link to="/periodinfo" title="정기권">정기권</router-link></li>
            <li><router-link to="/webdiscountcharge" title="웹 선불권">웹 선불권</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">정기권 신청</p>
          <ul class="depth">
            <li><router-link to="/periodinfo" title="정기권 안내">정기권 안내</router-link></li>
            <li><router-link to="/periodapplication" title="정기권 신청">정기권 신청</router-link></li>
            <li><router-link to="/periodlookup" title="정기권 조회/결제">정기권 조회/결제</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">정기권 신청</h3>
        <article>
          <!--table pc-->
          <div class="table horizontal-table web">
            <table>
              <caption>
                정기권 신청 테이블
              </caption>
              <colgroup>
                <col style="width: 15%" />
                <col style="width: 35%" />
                <col style="width: 15%" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">이름<span class="redDot">*</span></th>
                  <td>
                    <div class="flex">
                      <input type="text" v-model="waitingNm" title="이름 입력" />
                    </div>
                    <div class="error" v-if="!$v.waitingNm.required">필수 입력란입니다.</div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">주소<span class="redDot">*</span></th>
                  <td colspan="3">
                    <div class="address">
                      <div class="flex">
                        <input type="text" title="우편번호 입력" v-model="zipcode" readonly />
                        <button type="button" class="btn gray" @click="daumPostcodeBtn">우편번호</button>
                      </div>
                      <div class="error" v-if="!$v.zipcode.required">주소를 검색하세요.</div>
                      <div class="flex">
                        <input type="text" title="주소 입력" v-model="addr" readonly />
                        <input type="text" title="상세주소 입력" v-model="addrDetail" />
                      </div>
                      <!-- <div class="error" v-if="!$v.addrDetail.required">상세주소를 입력하세요.</div> -->
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">휴대폰번호<span class="redDot">*</span></th>
                  <td class="3">
                    <div class="tell">
                      <input type="text" maxlength="3" title="휴대폰 식별번호 선택" v-model="firstNum" />
                      <input type="text" maxlength="4" title="휴대폰 앞 4자리 입력" v-model="secondNum" />
                      <input type="text" maxlength="4" title="휴대폰 뒤 4자리 입력" v-model="lastNum" />
                    </div>
                    <div class="error" v-if="!$v.firstNum.required || !$v.secondNum.required || !$v.lastNum.required">
                      필수 입력란입니다.
                    </div>
                    <div
                      class="error"
                      v-if="
                        !(
                          $v.firstNum.mobileRegex &&
                          $v.secondNum.mobileRegex &&
                          $v.lastNum.mobileRegex &&
                          $v.firstNum.minLength &&
                          $v.secondNum.minLength &&
                          $v.lastNum.minLength
                        )
                      "
                    >
                      휴대폰 번호를 확인해주세요
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">신청 주차장<span class="redDot">*</span></th>
                  <td>
                    <select v-model="parking" title="신청 주차장 선택" @change="getPeriodAllotType(parking)">
                      <option :value="{ id: '', text: '' }">선택하세요.</option>
                      <option
                        v-for="(item, index) in parkingList"
                        :key="index"
                        :value="{
                          id: item.SECTN_ID,
                          text: item.PARKING_NM,
                          periodAllotType: item.PERIOD_ALLOT_TYPE,
                          useDivCd: item.PERIOD_USE_DIV_CD,
                          startDttm: item.START_DTTM,
                          endDttm: item.END_DTTM,
                        }"
                      >
                        {{ item.PARKING_NM }}
                      </option>
                    </select>
                    <div class="error" v-if="!$v.parking.required">필수 입력란입니다.</div>
                  </td>
                  <th scope="row">배정방식</th>
                  <td>{{ periodAllotType }}</td>
                </tr>
                <tr>
                  <th scope="row">주차구분<span class="redDot">*</span></th>
                  <td>
                    <select v-model="useDivCd" id="" title="주차구분 선택">
                      <option value="">선택</option>
                      <option v-if="useDivShow == 'UTM-001'" value="UTM-001">주야간</option>
                      <option v-if="useDivShow == 'UTM-001' || useDivShow == 'UTM-002'" value="UTM-002">주간</option>
                      <option v-if="useDivShow == 'UTM-001' || useDivShow == 'UTM-003'" value="UTM-003">야간</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th scope="row">차량번호<span class="redDot">*</span></th>
                  <td>
                    <input type="text" v-model="carNo" title="차량번호 입력" />
                  </td>
                  <th scope="row">차량 소유주명<span class="redDot">*</span></th>
                  <td>
                    <input type="text" title="차량 소유주명 입력" v-model="carOwnerNm" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">할인자격<span class="redDot">*</span></th>
                  <td colspan="3">
                    <div class="flex">
                      <input v-model="discountNm" type="text" class="middle" readonly />
                      <button :disabled="isLoading" v-if="isLoading" class="btn gray"><LoadingSpinner /></button>
                      <button
                        :disabled="isLoading"
                        v-if="!isLoading"
                        type="button"
                        class="btn gray"
                        @click="checkIrs('notFinal')"
                      >
                        할인적용확인
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">할인자격 변경<span class="redDot">*</span></th>
                  <td colspan="3">
                    <div class="flex">
                      <select v-model="discountCg" title="할인자격 변경" class="middle">
                        <option
                          v-for="(item, index) in discountCgList"
                          :key="index"
                          :value="{ id: item.code, text: item.codeNm }"
                        >
                          {{ item.codeNm }}
                        </option>
                      </select>
                      <div v-if="discountCg != '' && discountCg.id != 'DC001'" class="fileArea">
                        <p class="upload-name">{{ firstName }}</p>
                        <input
                          type="file"
                          class="hidden"
                          id="file"
                          ref="files"
                          @change="changeFile"
                          @click="resetFile"
                        />
                        <label for="file" class="btn gray">파일첨부</label>
                      </div>
                    </div>
                    <p class="info">첨부파일 (최대용량:20M) *이미지 파일 (jpg, jpeg, gif, png, pdf)</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--//table pc-->

          <!--table mobile-->
          <div class="table horizontal-table mobile">
            <table>
              <caption>
                정기권 신청 테이블
              </caption>
              <colgroup>
                <col style="width: 35%" />
                <col style="width: 65%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">이름<span class="redDot">*</span></th>
                  <div><input type="text" v-model="waitingNm" title="이름 입력" /></div>
                  <div class="error" v-if="!$v.waitingNm.required">필수 입력란입니다.</div>
                </tr>
                <tr>
                  <th scope="row">주소<span class="redDot">*</span></th>
                  <td>
                    <div class="address">
                      <div class="flex">
                        <input type="text" title="우편번호 입력" v-model="zipcode" readonly />
                        <button type="button" class="btn gray" @click="daumPostcodeBtn">우편번호</button>
                      </div>
                      <div class="flex">
                        <input type="text" title="주소 입력" v-model="addr" readonly />
                        <input type="text" title="상세주소 입력" v-model="addrDetail" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">휴대폰번호<span class="redDot">*</span></th>
                  <td>
                    <div class="tell">
                      <input type="text" maxlength="3" title="휴대폰 식별번호 선택" v-model="firstNum" />
                      <input type="text" maxlength="4" title="휴대폰 앞 4자리 입력" v-model="secondNum" />
                      <input type="text" maxlength="4" title="휴대폰 뒤 4자리 입력" v-model="lastNum" />
                    </div>
                    <div class="error" v-if="!$v.firstNum.required || !$v.secondNum.required || !$v.lastNum.required">
                      필수 입력란입니다.
                    </div>
                    <div
                      class="error"
                      v-if="
                        !(
                          $v.firstNum.mobileRegex &&
                          $v.secondNum.mobileRegex &&
                          $v.lastNum.mobileRegex &&
                          $v.firstNum.minLength &&
                          $v.secondNum.minLength &&
                          $v.lastNum.minLength
                        )
                      "
                    >
                      휴대폰 번호를 확인해주세요
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">신청 주차장<span class="redDot">*</span></th>
                  <td>
                    <select v-model="parking" title="신청 주차장 선택" @change="getPeriodAllotType(parking)">
                      <option :value="{ id: '', text: '' }">선택하세요.</option>
                      <option
                        v-for="(item, index) in parkingList"
                        :key="index"
                        :value="{
                          id: item.SECTN_ID,
                          text: item.PARKING_NM,
                          periodAllotType: item.PERIOD_ALLOT_TYPE,
                          useDivCd: item.PERIOD_USE_DIV_CD,
                          startDttm: item.START_DTTM,
                          endDttm: item.END_DTTM,
                        }"
                      >
                        {{ item.PARKING_NM }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th scope="row">배정방식</th>
                  <td>선착순</td>
                </tr>
                <tr>
                  <th scope="row">주차구분<span class="redDot">*</span></th>
                  <td>
                    <select v-model="useDivCd" id="" title="주차구분 선택">
                      <option value="">선택</option>
                      <option v-if="useDivShow == 'UTM-001'" value="UTM-001">주야간</option>
                      <option v-if="useDivShow == 'UTM-001' || useDivShow == 'UTM-002'" value="UTM-002">주간</option>
                      <option v-if="useDivShow == 'UTM-001' || useDivShow == 'UTM-003'" value="UTM-003">야간</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th scope="row">차량번호<span class="redDot">*</span></th>
                  <td>
                    <input type="text" v-model="carNo" title="차량번호 입력" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">차량 소유주명<span class="redDot">*</span></th>
                  <td>
                    <input type="text" title="차량 소유주명 입력" v-model="carOwnerNm" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">할인자격<span class="redDot">*</span></th>
                  <td colspan="3">
                    <div class="flex wrap">
                      <input v-model="discountNm" type="text" class="middle" readonly />
                      <button :disabled="isLoading" v-if="isLoading" class="btn gray"><LoadingSpinner /></button>
                      <button
                        :disabled="isLoading"
                        v-if="!isLoading"
                        type="button"
                        class="btn gray"
                        @click="checkIrs('notFinal')"
                      >
                        할인적용확인
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">할인자격 변경<span class="redDot">*</span></th>
                  <td colspan="3">
                    <div class="flex" style="flex-direction: column">
                      <select v-model="discountCg" title="할인자격 변경" class="middle">
                        <option
                          v-for="(item, index) in discountCgList"
                          :key="index"
                          :value="{ id: item.code, text: item.codeNm }"
                        >
                          {{ item.codeNm }}
                        </option>
                      </select>
                      <div v-if="discountCg != '' && discountCg.id != 'DC001'" class="fileArea">
                        <p class="upload-name">{{ firstName }}</p>
                        <input
                          type="file"
                          class="hidden"
                          id="file"
                          ref="files"
                          @change="changeFile"
                          @click="resetFile"
                        />
                        <label for="file" class="btn gray">파일첨부</label>
                      </div>
                    </div>
                    <p class="info">첨부파일 (최대용량:20M) *이미지 파일 (jpg, jpeg, gif, png, pdf)</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--//table mobile-->
        </article>
        <article class="btnArea">
          <button type="button" class="btn gray" @click="$router.push('/periodinfo')">취소</button>
          <button type="button" class="btn blue" @click="periodApplication">확인</button>
        </article>
      </div>
    </section>

    <zip-code-modal v-if="isZipcodeModal">
      <template #info> 우편번호 </template>
      <template #content>
        <article>
          <VueDaumPostcode @complete="searchedAddress" />
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </zip-code-modal>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import ZipCodeModal from '../../../components/PopupType1.vue';
import { VueDaumPostcode } from 'vue-daum-postcode';
import { required, minLength, helpers, or } from 'vuelidate/lib/validators';
import LoadingSpinner from '../../../components/LoadingSpinner.vue';
import parkingMap from "../parking/ParkingMap.vue";
const carNoRegex = /^\s*([가-히]{2}){0,1}\s*[0-9]{2,3}[\s]*[가-히]{1}[\s]*[0-9]{4}\s*$/gi;
const carNoRegexDipl = /^\s*([외교,영사,준외,협정,국기,준영,대표]{2}){0,1}\s*[0-9]{3}[\s]*[-]{1}[\s]*[0-9]{3}\s*$/gi;

const mobileRegex = helpers.regex('mobileRegex', /\d$/);

export default {
  data() {
    return {
      parkingList: [],
      parking: {id: '', text: ''},
      periodAllotType: '주차장을 선택해주세요.',
      isZipcodeModal: false,

      waitingNm: '',
      carOwnerNm: '',
      carNo: '',
      zipcode: '',
      addr: '',
      addrDetail: '',
      firstNum: '',
      secondNum: '',
      lastNum: '',
      useDivCd: '',

      discountCd: '',
      discountNm: '',
      discountList: [],
      discountCg: '',
      discountCgList: [],
      firstName: '',

      eFiles: '',
      afterCheckIrs: false,
      isLoading: false,
      useDivShow: '',

      startDttm: '',
      endDttm: '',
    };
  },

  components: {
    ZipCodeModal,
    VueDaumPostcode,
    LoadingSpinner,
  },

  validations: {
    waitingNm: {
      required,
    },
    parking: {
      required,
    },
    carOwnerNm: {
      required,
    },
    // discountCd: {
    // 	required
    // },
    zipcode: {
      required,
    },
    addr: {
      required,
    },
    // addrDetail: {
    //     required
    // },
    firstNum: {
      required,
      minLength: minLength(3),
      mobileRegex,
    },
    secondNum: {
      required,
      minLength: minLength(3),
      mobileRegex,
    },
    lastNum: {
      required,
      minLength: minLength(3),
      mobileRegex,
    },
    useDivCd: {
      required,
    },
  },

  mounted() {
    this.empInfoSet();
    this.getParkingList();
  },

  methods: {
    searchedAddress(data) {
      this.zipcode = data.zonecode;
      if (data.userSelectedType == 'R') {
        this.addr = data.address;
      } else {
        this.addr = data.jibunAddress;
      }
      this.isZipcodeModal = false;
    },

    getPeriodAllotType(parking) {
      if (this.useDivCd != '') {
        this.useDivCd = '';
      }
      this.useDivShow = parking.useDivCd;

      this.startDttm = parking.startDttm;
      this.endDttm = parking.endDttm;
      
      switch (parking.periodAllotType) {
        case 'RAFFLE':
          this.periodAllotType = '추첨제';
          break;
        case 'FCOME':
          this.periodAllotType = '선착순';
          break;
        default:
          this.periodAllotType = '주차장을 선택해주세요.';
          break;
      }
    },

    async periodApplication() {
      if (this.$v.$invalid) {
        if (this.carNo == '' || !(carNoRegex.test(this.carNo) || carNoRegexDipl.test(this.carNo))) {
          alert('차량번호를 형식에 맞게 적어주세요');
        } else {
          alert('필수 항목(*)을 모두 채워주세요');
        }
        return;
      }
      if (await this.checkIrs('final')) {
        await this.applicationPeriod();
      }
    },

    async checkIrs(clickBtn) {
      if (this.discountCg.id != 'DC001' && this.eFiles == '' && this.discountCg != '') {
        alert('할인변경 신청시에는 증빙자료를 첨부해주세요.');
        return false;
      }
      if (clickBtn == 'final') {
        if (this.discountCd != '') return true;
      }

      const apiParams = new Map();
      apiParams.set('carNo', this.carNo);
      apiParams.set('carOwnerNm', this.carOwnerNm);

      this.isLoading = true;
      const res = await axios('get', '/api/reduction/irs.json', Object.fromEntries(apiParams));
      this.isLoading = false;

      const data = res.data.value.dcList;

      if (data.length == 0) {
        alert('할인 조회 결과 일반으로 적용됩니다.');
        this.discountCd = 'DC001';
        this.discountNm = '일반';
      } else {
        this.discountCd = data[0].dcCode;
        this.discountNm = data[0].note;
      }
      this.afterCheckIrs = true;
      return true;
    },

    async checkTime() {
      const nowDate = new Date();
      const apiParams = new FormData();
      apiParams.append('sectnId', this.parking.id);
      apiParams.append('nowDate', this.nowDate);
      const res = await axios('post', '/api/period/checkTime.json', apiParams);
      const data = res.data.value;
      if (data != null) {
        if (data.END_DTTM < nowDate) {
          alert(data.PARKING_NM + ' 주차장의 정기권 신청시간이 마감되었습니다.');
        }
      }
    },

    async applicationPeriod() {
      const telNo = this.firstNum + this.secondNum + this.lastNum;

      const params = {
        waitingNm: this.waitingNm,
        zipcode: this.zipcode,
        addr: this.addr,
        addrDetail: this.addrDetail,
        telNo: telNo,
        sectnNm: this.parking.text,
        sectnId: this.parking.id,
        carOwnerNm: this.carOwnerNm,
        carNo: this.carNo,
        discountCd: this.discountCd,
        discountNm: this.discountNm,
        discountCg: this.discountCg,
        periodAllotTypeKor: this.periodAllotType,
        periodAllotType: this.parking.periodAllotType,
        useDivCd: this.useDivCd,
        startDttm: this.startDttm,
        endDttm: this.endDttm,
      };

      if (this.eFiles != ('' || undefined)) {
        params.eFiles = this.eFiles;
      }
      this.$router.push({
        name: 'periodresult',
        params: { data: params },
      });
    },

    changeFile(e) {
      const file = e.target.files[0];

      if (file.size > 2000000) {
        alert('최대 20mb까지 업로드할 수 있습니다.');
        this.resetFile();
        return;
      }

      if (
        file['type'] === 'image/jpeg' ||
        file['type'] === 'image/png' ||
        file['type'] === 'image/gif' ||
        file['type'] === 'image/jpg' ||
        file['type'] === 'image/pdf' ||
        file['type'] == 'application/pdf'
      ) {
        this.firstName = file.name;
        this.eFiles = file;
      }
    },

    resetFile() {
      this.$refs.files.value = '';
      this.eFiles = [];
    },

    initEFiles() {
      if (this.eFiles.length == 0) {
        this.eFiles = '';
      }
    },

    empInfoSet() {
      this.waitingNm = this.$store.state.empNm;
      this.carOwnerNm = this.$store.state.empNm;
      this.carNo = this.$store.state.empCarNo;
      this.zipcode = this.$store.state.zipcode;
      this.addr = this.$store.state.addr;
      this.addrDetail = this.$store.state.addrDetail;
      if (!this.$store.state.empMobile) {
        return;
      }
      this.firstNum = this.$store.state.empMobile.substr(0, 3);
      this.secondNum = this.$store.state.empMobile.substr(3, 4);
      this.lastNum = this.$store.state.empMobile.substr(7);
    },
    async getParkingList() {
      const res = await axios('get', '/api/period/getParkingAndDiscountList.json');
      const data = res.data;
      this.parkingList = data.parkingList.filter(v => v.PERIOD_CELL_CNT != '0');
      this.discountList = data.discountList;
      this.discountCgList = data.discountCgList;
      this.discountCg = { id: data.discountCgList[0].code, text: data.discountCgList[0].codeNm };
    },
    CancleBtn() {
      this.isZipcodeModal = false;
    },
    daumPostcodeBtn() {
      this.isZipcodeModal = true;
    },
  },
};
</script>
